import $ from "jquery";
import {GPProjectView} from "./gp-projectview.js";
import {writable, get} from "svelte/store";
import {mode} from "./gp.js";

export const modeStore = writable('hovering');
export const sizeStore = writable('optionBrush2');


export let GPContextCloner = {
    clonerLayer: null, //This is KonvaLayer from GPProjectView, part of the final view. On this we also display cursor.
    brushSize: null,
    brushSizes: {'optionBrush1': 15, 'optionBrush2': 30, 'optionBrush3': 50},
    clonerCursor: null,
    clonerCursorLastPos: null,
    clonerCrosshair: null,
    clonerCrosshairPos: null,
    clonerCrosshairOffset: null,
    clonerContext: null, //js 2d drawing context
    storesInitiated: false,

    init: function (clonerLayer) {
        GPContextCloner.clonerLayer = clonerLayer;

        GPContextCloner.clonerCursor = new Konva.Circle({
            x: 100,
            y: 100,
            radius: 30,
            stroke: 'white',
            strokeWidth: 1
          }).visible(false);
        GPContextCloner.clonerLayer.add(GPContextCloner.clonerCursor);

        GPContextCloner.clonerCrosshair = new Konva.Circle({
            x: -100,
            y: -100,
            radius: 30,
            stroke: 'blue',
            strokeWidth: 1
          }).visible(false);
        GPContextCloner.clonerLayer.add(GPContextCloner.clonerCrosshair);

        GPContextCloner.clonerLayer.on("mouseenter", GPContextCloner.activateCursor);
        GPContextCloner.clonerLayer.on("mouseleave", GPContextCloner.disableClonerCursor);
        GPContextCloner.clonerLayer.on('mousemove',GPContextCloner.moveClonerCursorHandler);
        GPContextCloner.clonerLayer.listening(false);

        if (!GPContextCloner.storesInitiated) {
            sizeStore.subscribe((s) => {GPContextCloner.brushSize = s; GPContextCloner.updateClonerCursorMode()});

            mode.subscribe((m) => {
                if (m === "Cloner" && !GPContextCloner.clonerLayer.listening())
                    GPContextCloner.activate();
                if (m !== "Cloner" && GPContextCloner.clonerLayer.listening())
                    GPContextCloner.deactivate()
            })
            GPContextCloner.storesInitiated = true;
        }
    },

    activate: function() {
        $(document).off("keydown", GPContextCloner.handleKeyboard).on("keydown", GPContextCloner.handleKeyboard);
        modeStore.set("hovering");
        sizeStore.set("optionBrush2");
        $(document).trigger('GPContextClonerChanged');
        GPContextCloner.resetCloner();
        GPContextCloner.setupClonerCursor();
        GPContextCloner.clonerLayer.listening(true);
    },

    deactivate: function() {
        $(document).off("keydown", GPContextCloner.handleKeyboard);
        GPContextCloner.clonerLayer.listening(false);
        GPContextCloner.disableClonerCursor();
    },

    onresize: function () {
        GPContextCloner.updateClonerCursorMode()
    },


    resetCloner: function () {
        var isPaint = false;

        // now we need to bind some events
        // we need to start drawing on mousedown
        // and stop drawing on mouseup
        GPContextCloner.clonerLayer.off('touchstart mousedown').on('touchstart mousedown', function (event) {
            if (get(modeStore) ==="hovering") {
                GPContextCloner.clonerCrosshairPos = GPProjectView.getPointerPosition(event);
                modeStore.set("offsetting");
                return;
            }
            if (get(modeStore) ==="offsetting") {
                modeStore.set("painting");
                var pos = GPProjectView.getPointerPosition(event);
                GPContextCloner.clonerCrosshairOffset = {
                    x: (GPContextCloner.clonerCrosshairPos.x - pos.x) / GPProjectView.sceneScale,
                    y: (GPContextCloner.clonerCrosshairPos.y - pos.y) / GPProjectView.sceneScale
                };
                $(document).trigger('GPContextClonerChanged');

                var oc = document.createElement('canvas'),
                    octx = oc.getContext('2d');

                oc.width = GP.project.sizeX;
                oc.height = GP.project.sizeY;
                octx.drawImage(GP.project.backgroundCanvas, -GPContextCloner.clonerCrosshairOffset.x, -GPContextCloner.clonerCrosshairOffset.y, oc.width, oc.height);

                GPContextCloner.clonerContext = GP.project.backgroundCanvas.getContext('2d');
                GPContextCloner.clonerContext.lineJoin = "round";
                GPContextCloner.clonerContext.lineCap = "round";
                GPContextCloner.clonerContext.lineWidth = GPContextCloner.brushSize * GP.project.sizeX / 1024;

                var pattern = GPContextCloner.clonerContext.createPattern(oc, 'repeat');
                GPContextCloner.clonerContext.strokeStyle = pattern;
                GPContextCloner.clonerContext.fillStyle = pattern;

                GPContextCloner.updateClonerCursorMode();

                isPaint = true;
                GP.saveUndo("background", GP.project.backgroundCanvas.toDataURL('image/jpeg'));
                GPContextCloner.clonerCursorLastPos = GPProjectView.getPointerPosition(event);
                return;
            }
            if (get(modeStore) ==="painting") {
                GP.saveUndo("background", GP.project.backgroundCanvas.toDataURL('image/jpeg'));
                isPaint = true;
                GPContextCloner.clonerCursorLastPos = GPProjectView.getPointerPosition(event);
            }
        });


        GPContextCloner.clonerLayer.off('touchend mouseup').on('touchend mouseup', function () {
            isPaint = false;
        });

        //if we're incidentaly leave drawing area and return later - start line at
        //the new entry point
        function updateCursorPos(event) {
            GPContextCloner.clonerCursorLastPos = GPProjectView.getPointerPosition(event);
            if (event.evt.buttons !== 1) isPaint = false;
        }
        GPContextCloner.clonerLayer.off('mouseenter', updateCursorPos).on('mouseenter', updateCursorPos);

        // and core function - drawing
        function doDrawFunc (event) {
            if (!isPaint)
                return;

            var lastLocalPos = {
                x: GPContextCloner.clonerCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextCloner.clonerCursorLastPos.y / GPProjectView.sceneScale
            };

            var pos = GPProjectView.getPointerPosition(event);

            var localPos = {
                x: pos.x / GPProjectView.sceneScale,
                y: pos.y / GPProjectView.sceneScale
            };

            GPContextCloner.doCut(lastLocalPos, localPos);

            GPContextCloner.clonerCursorLastPos = pos;
        }
        GPContextCloner.clonerLayer.off('touchmove mousemove', doDrawFunc).on('touchmove mousemove', doDrawFunc);

        // Good. Now we need to get access to GPProjectView.clonerContext element


    },

    doCut: function(from, to) {
        if (get(modeStore) ==="painting") {
            GPContextCloner.clonerContext.globalCompositeOperation = 'source-over';
            GPContextCloner.clonerContext.beginPath();
            GPContextCloner.clonerContext.moveTo(from.x, from.y);
            GPContextCloner.clonerContext.lineTo(to.x, to.y);
            GPContextCloner.clonerContext.lineWidth = GPContextCloner.brushSize * GP.project.sizeX / 1024;
            GPContextCloner.clonerContext.stroke();

            GPContextCloner.clonerLayer.draw();
            $(document).trigger('GPContextClonerChanged');
        }
    },

    moveClonerCursor: function(pos) {
        GPContextCloner.clonerCursor.setX(pos.x);
        GPContextCloner.clonerCursor.setY(pos.y);
        if (GPContextCloner.clonerCrosshairOffset && get(modeStore) ==="painting") {
            GPContextCloner.clonerCrosshair.visible(true);
            GPContextCloner.clonerCrosshair.setX(pos.x + GPContextCloner.clonerCrosshairOffset.x * GPProjectView.sceneScale);
            GPContextCloner.clonerCrosshair.setY(pos.y + GPContextCloner.clonerCrosshairOffset.y * GPProjectView.sceneScale);
        }
        if (GPContextCloner.clonerCrosshairPos && get(modeStore) ==="offsetting") {
            GPContextCloner.clonerCrosshair.visible(true);
            GPContextCloner.clonerCrosshair.setX(GPContextCloner.clonerCrosshairPos.x);
            GPContextCloner.clonerCrosshair.setY(GPContextCloner.clonerCrosshairPos.y);
        }
        if (get(modeStore) ==="hovering")
            GPContextCloner.clonerCrosshair.visible(false);
    },

    moveClonerCursorHandler: function(e) {
        var pos = GPProjectView.getPointerPosition(e);
        GPContextCloner.moveClonerCursor(pos);
    },

    updateClonerCursorMode: function() {
        var size = GPContextCloner.brushSizes[GPContextCloner.brushSize];
        GPContextCloner.clonerCursor.setRadius(size/2 * GPProjectView.width / 1024);
        GPContextCloner.clonerCrosshair.setRadius(size/2 * GPProjectView.width / 1024);
        if (GPContextCloner.clonerContext) GPContextCloner.clonerContext.lineWidth = size * GP.project.sizeX / 1024;
    },

    setupClonerCursor: function() {
        if (!GPContextCloner.clonerCursorLastPos)
            GPContextCloner.clonerCursorLastPos = {
                x: $('#GPProjectView').innerWidth() / 2,
                y: $('#GPProjectView').innerHeight() * 0.8
            };
        GPContextCloner.updateClonerCursorMode();
        GPContextCloner.clonerCursor.setZIndex(2);
        GPContextCloner.clonerCrosshair.setZIndex(1);
        GPContextCloner.moveClonerCursor(GPContextCloner.clonerCursorLastPos);
        GPContextCloner.activateCursor();
    },

    disableClonerCursor: function() {
        GPContextCloner.clonerCursor.visible(false);
        GPContextCloner.clonerCrosshair.visible(false);
    },

    activateCursor: function() {
        GPContextCloner.clonerCursor.visible(true);
        GPContextCloner.clonerCrosshair.visible(true);
    },

    handleKeyboard: function (e) {
        //Further actions only when project area active and applying textures
        if (($(".GPProjectView.active").length)) {
            var lastPos = {
                x: GPContextCloner.clonerCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextCloner.clonerCursorLastPos.y / GPProjectView.sceneScale
            };
            switch (e.which) {
                case 37: // left
                    GPContextCloner.clonerCursorLastPos.x -= 5;
                    break;

                case 38: // up
                    GPContextCloner.clonerCursorLastPos.y -= 5;
                    break;

                case 39: // right
                    GPContextCloner.clonerCursorLastPos.x += 5;
                    break;

                case 40: // down
                    GPContextCloner.clonerCursorLastPos.y += 5;
                    break;

                case 27: // esc
                    GP.restoreFocus();
                    break;

                default:
                    return; // exit this handler for other keys

                    e.preventDefault(); // prevent the default action (scroll / move caret)
            }
            var newPos = {
                x: GPContextCloner.clonerCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextCloner.clonerCursorLastPos.y / GPProjectView.sceneScale
            };
            GPContextCloner.moveClonerCursor(GPContextCloner.clonerCursorLastPos);
            if (e.shiftKey) GPContextCloner.doCut(lastPos, newPos);
        }
    }

};

